import { Stack, Typography } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useGetWeightLoggerQuery } from "src/api/services/batchesApi";

const TrackerCoupon = () => {
  const { data: weightLog } = useGetWeightLoggerQuery();
  const { t } = useTranslation();
  const component = "weight-tracker.coupon";

  const batch = useMemo(() => {
    if (weightLog == null) return null;

    return weightLog.batch;
  }, [weightLog]);

  const coupon = useMemo(() => {
    if (weightLog == null) return null;

    return weightLog.coupon;
  }, [weightLog]);

  const logCount = useMemo(() => {
    if (batch == null) return 0;

    return batch.count;
  }, [batch]);

  if (coupon != null) {
    return (
      <Typography color="#3BB273">
        {t(`${component}.generated`, "Coupon added: $10 off")}
      </Typography>
    );
  }

  if (logCount === 7 && coupon == null) {
    return (
      <Typography color="#3BB273">
        {t(`${component}.unlocked`, "Reward unlocked - pending review")}
      </Typography>
    );
  }

  return (
    <Stack direction={"row"} spacing={0.5}>
      <Typography>
        {t(`${component}.progress.text`, "Progress Reward:")}
      </Typography>
      <Typography color="#3BB273">
        {t(`${component}.count`, `{{count}} of 7 completed`, {
          count: logCount,
        })}
      </Typography>
    </Stack>
  );
};

export default TrackerCoupon;
